module.exports = __webpack_public_path__ + "static/media/valor1.2ab81d28.png";